/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * A GA4 shaped version of what was purchased
 */
export interface Item {
  id: string;
  item_id: string;
  item_name: string;
  item_category: string;
  quantity?: number;
  price?: number | null;
  discount?: number | null;
}
